import React from "react";

export default ({messages, toggle, toggleChatContent}) => {
    if(!messages || !messages.count || messages.count < 1){
        return  <div className="toggle-dialog-header">
                    <div className="qty-messages">Сообщений нет</div>
                </div>
    }
    
    return (
        <div className="toggle-dialog-header">
            <a href=""
                className="show-dialog-link"
                onClick={(event) => toggleChatContent(event)}>
                    {toggle ? 'Показать переписку' : 'Скрыть переписку'}
            </a>
            <div className="qty-messages">{messages.count} сообщений</div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Chat/ChatHeader.js